import { useCallback } from "react";
import { toast } from "react-hot-toast";
import { useHandleError } from "@/Utils/CustomHooks/useHandleError";

export const useDisplayMessage = () => {
    const { handleError } = useHandleError();

    const displayMessage = useCallback(
        (type: "error" | "success", messageKey: string) => {
            if (type === "error") {
                handleError(messageKey);
                toast.error(messageKey);
            } else {
                toast.success(messageKey);
            }
        },
        [handleError]
    );

    return { displayMessage };
};